import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Briefcase, FolderOpen, Home, Wallet } from "lucide-react";
import AppHeader from "@/components/AppHeader";
import { api } from "@/lib/api";

const ICONS = { home: Home, work: Briefcase, pay: Wallet, file: FolderOpen };
const DEFAULT_LABELS = { home: "Home", work: "My work", pay: "Time and pay", file: "My file" };
const PATHS = { home: "/provider-portal", work: "/provider-portal/work", pay: "/provider-portal/pay", file: "/provider-portal/file" };

export const ProviderTabBar = ({ tabs }) => (
  <nav className="provider-tab-bar" data-testid="provider-tab-bar" aria-label="Provider portal">
    {(tabs || Object.keys(PATHS).map((key) => ({ key, label: DEFAULT_LABELS[key] }))).map((tab) => {
      const Icon = ICONS[tab.key] || Home;
      return (
        <NavLink key={tab.key} end={tab.key === "home"} to={PATHS[tab.key]} className={({ isActive }) => `provider-tab ${isActive ? "active" : ""}`} data-testid={`provider-tab-${tab.key}`}>
          <Icon size={20} />
          <span>{tab.label}</span>
        </NavLink>
      );
    })}
  </nav>
);

export const ProviderShell = ({ title, eyebrow, back, children, testId }) => {
  const [tabs, setTabs] = useState(null);
  useEffect(() => {
    api.get("/providers/me/tabs").then((response) => setTabs(response.data.tabs)).catch(() => setTabs(null));
  }, []);
  return (
    <div className="provider-mobile-shell" data-testid={testId || "provider-shell"}>
      <AppHeader />
      <main className="provider-mobile-main">
        {(eyebrow || title || back) && (
          <header className="provider-mobile-head">
            {back && <NavLink className="provider-back" data-testid="provider-back" to={back}>‹ Back</NavLink>}
            {eyebrow && <p className="eyebrow">{eyebrow}</p>}
            {title && <h1>{title}</h1>}
          </header>
        )}
        {children}
      </main>
      <ProviderTabBar tabs={tabs} />
    </div>
  );
};
